import { FC, useEffect, useState } from 'react'
import { ConfigProvider, App } from 'antd'

import 'antd/dist/reset.css'
import { Provider } from 'react-redux'
import ShRouter from './Router'
import theme from '@/constants/theme'
import store from './store'
import { LanguageEnum, useTranslation } from '@/services/i18n'
import enUS from 'antd/locale/en_US'
import zhCN from 'antd/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import Empty from './components/Empty'
import * as Sentry from '@sentry/react'

const ConfigMessage: FC<any> = ({ children }) => {
  const app = App.useApp()
  // useGetWorkspaceUserInfo()
  // useGetLocalBackupState()
  useEffect(() => {
    window.shMessage = app.message
    window.shModal = app.modal
  }, [app.message])
  return children
}

const Application = () => {
  const [locale, setLocale] = useState(enUS)
  const [lang, setLang] = useState('en-lang')
  const { i18n } = useTranslation()

  useEffect(() => {
    switch (i18n.language) {
      case LanguageEnum.EN_US:
        setLocale(enUS)
        setLang('en-lang')
        break
      case LanguageEnum.ZH_CN:
        setLocale(zhCN)
        setLang('zh-lang')
        break
    }
  }, [i18n.language])

  return (
    <ConfigProvider renderEmpty={() => <Empty />} locale={locale} theme={theme} prefixCls="sh">
      <Provider store={store}>
        <App className={lang} style={{ height: '100%' }}>
          <ConfigMessage>
            <ShRouter />
          </ConfigMessage>
        </App>
      </Provider>
    </ConfigProvider>
  )
}

export default Sentry.withProfiler(Application)
